import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes,RouterModule } from '@angular/router';
import { UserListComponent } from "./user-list/user-list.component";
import { UserEditComponent } from "./user-edit/user-edit.component";
import { UserNewComponent } from "./user-new/user-new.component";
import { UserDeleteComponent } from "./user-delete/user-delete.component";

const userRoutes: Routes = [
    {path: '',component: UserListComponent}
    ,{path: 'new', component: UserNewComponent }
    ,{path: ':userId/edit', component: UserEditComponent}
    ,{path: ':userId/delete', component: UserDeleteComponent}
  ];
@NgModule({
  imports: [
    RouterModule.forChild(userRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class UsersRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/users/users-routing.module.ts